module.exports = __webpack_public_path__ + "static/media/different-value.d2432836.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/different-value.svg
// module id = 2445
// module chunks = 0